'use client';

import LiTV from '@fe-news/components/LiTV';
import Popin from '@fe-news/components/NewsDetail/Popin';
import MobileAdProfiles from '@fe-news/constants/DFP/MobileAdProfiles';
import { NewsCategory } from '@fe-news/constants/categories';
import { styled } from '@linaria/react';
import dynamic from 'next/dynamic';

type DynamicLoadSubDetailPageProps = {
  data: News;
  isDesktop: boolean;
};

const SubContainer = styled.div`
  border-radius: 6px;
  position: relative;
  background-color: inherit;
  box-shadow: none;
  padding-top: 0;
`;

const NewsSkeleton = dynamic(() => import('@fe-common-ui/LoadingSkeleton').then(library => library.NewsSkeleton));

const Interested = dynamic(() => import('@fe-news/components/NewsDetail/Interested'), {
  loading: () => <NewsSkeleton />,
  ssr: false
});

const AdSlot = dynamic(() => import('@fe-news/components/DynamicAd/BaseDynamicAd'), {
  loading: () => null,
  ssr: false
});

const Related = dynamic(() => import('@fe-news/components/NewsDetail/Related'), {
  loading: () => <NewsSkeleton />,
  ssr: false
});

const DynamicLoadSubDetailPage = ({ data, isDesktop }: DynamicLoadSubDetailPageProps) => {
  const { breadcrumbs } = data;

  const category = Array.isArray(breadcrumbs) ? (breadcrumbs[0]?.slug as NewsCategory) : NewsCategory.HEADLINE;

  return (
    <SubContainer>
      {/* 廣告 (Mobile Only) */}
      <AdSlot profile={MobileAdProfiles.detailUnderShare100} />
      {/* 推薦閱讀 */}
      <Popin isDesktop={isDesktop} />
      {/* LiTV */}
      {isDesktop && <LiTV />}
      {/* 相關新聞 */}
      <Related id={data.newsId} />
      {/* 您可能感興趣 */}
      <Interested category={category} />
    </SubContainer>
  );
};

export default DynamicLoadSubDetailPage;
